<style lang="css" scoped>

.main1 {
    max-width: 100%;
    max-height: 100%;
}

.nav-bar {
    position: fixed;
}

i,
img {
    vertical-align: middle;
    margin-right: 5%;
}

ul {
    list-style: none;
    vertical-align: middle;
    padding-left: 0px;
}

li:hover {
    cursor: pointer;
    background-color: #2a2a2e;
}

.sub li {
    padding-left: 10%;
}

li {
    margin-top: 1px;
    vertical-align: middle;
    color: white;
    width: 100%;
    height: 100%;
    padding: 4%;
    background-color: #222226;
    border: 1px;
}

.side-nav {
    overflow: auto;
    height: 100%;
    width: 20%;
    position: fixed;
    z-index: 1;
    left: 0;
    background-color: #2a2a2e;
    transition: 0.5s;
}

.home-container {
    height: 100%;
    width: 80%;
    transition: 0.3s;
    margin-left: 20%;
}

.slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

</style>

<template>

<v-container style="min-height: 100%; min-width: 100%;">
    <v-row style="min-height: 48px;">
        <NavBar test="Home" style="position: fixed; z-index: 99;" class="w-100"></NavBar>
    </v-row>
    <v-row style="height: calc(100vh - 48px);">
        <v-col class="pa-1" cols="3" style="width: 25%; height: calc(100vh - 48px); position: fixed; top: 48px;">
            <v-card style="min-height: 100%;">
                <v-navigation-drawer style="height: 100%;" permanent width="100%">
                    <v-list>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="title">{{getName()}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-list flat rounded>
                        <v-list-item-group v-model="item" color="primary">
                            <v-list-item @click="goto(4)">
                                <v-list-item-icon>
                                    <v-icon>place</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>View Map</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="goto(0)">
                                <v-list-item-icon>
                                    <v-icon>mdi-calendar</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Calendar</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="goto(1)">
                                <v-list-item-icon>
                                    <v-icon>mdi-refresh</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Reschedule Requests</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="goto(2)">
                                <v-list-item-icon>
                                    <v-icon>mdi-history</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Job History</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-col>
        <v-col class="pa-1" cols="9" style="min-height: calc(100vh - 48px); left: 25%">
            <v-card style="height: 100%;">
                <router-view></router-view>
            </v-card>
        </v-col>
    </v-row>

</v-container>

</template>

<script>

import NavBar from '../NavBar.vue'

export default {
    components: {
        NavBar
    },
    created() {
        this.getLocations();
    },
    data: () => ({
        selected: '',
        isLoading: false,
        item: null
    }),
    methods: {
        inventory() {
                if (this.selected.localeCompare('Jobs') == 0)
                    this.selected = '';
                else
                    this.selected = 'Jobs';
            },
            goto(index) {
                switch (index) {
                    case 0:
                        this.$router.push('/scheduling/calendar');
                        break;
                    case 2:
                        this.$router.push('/scheduling/history');
                        break;
                    case 1:
                        this.$router.push('/scheduling/reschedule');
                        break;
                    case 3:
                        this.$router.push('/scheduling/technicians');
                        break;
                    case 4:
                        this.$router.push('/scheduling/map')
                        break;

                }
            },
            shouldShowInventoryRelated() {
                return this.$store.state.isManager || this.$store.state.isAdmin;
            },
            getLocations() {
                this.$api.getLocations().then(res => {
                    if (res.status == 200)
                        this.$store.state.locations = res.data;
                })
            },
            getName() {
                return this.$store.state.token.name;
            }
    }
}

</script>
